import {
  API_URL
} from '../constants'

export const V1_URL = `${API_URL}/v1/ingredient_categories`

export const V1_INGREDIENT_CATEGORIES = `${V1_URL}`

export const V1_INGREDIENT_CATEGORY_BY_ID = (id) => `${V1_URL}/${id}`

export const V1_CREATE_ALL_OUTLET = `${V1_INGREDIENT_CATEGORIES}/create_all_outlet`

export const V1_INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT = (id) => `${V1_INGREDIENT_CATEGORIES}/${id}/assigns`



// WEBPACK FOOTER //
// ./app/api/ingredientCategories/constants.js